import React from 'react';

import { AddCircle as AddCircleIcon } from '@mui/icons-material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Box } from '@mui/material';

import { sharedClasses } from '../CustomUIElements/sharedClasses';

const CreateButton = ({
  id,
  ariaLabel,
  onClick,
  isOpen,
  disableDropDown = false,
  label = 'Create'
}: {
  id: string;
  ariaLabel: string;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  isOpen?: boolean;
  disableDropDown?: boolean;
  label?: string;
}) => (
  <Box
    aria-label={ariaLabel}
    data-testid={id}
    id={id}
    onClick={onClick}
    sx={{
      ...sharedClasses.createButtonAction,
      '& div': {
        ...sharedClasses.createButtonDiv
      },
      ...(disableDropDown && {
        '& div': {
          ...sharedClasses.createButtonDiv,
          paddingRight: '16px'
        }
      })
    }}
  >
    <AddCircleIcon sx={sharedClasses.addIcon} />
    <Box>{label}</Box>
    {!disableDropDown && (
      <ArrowDropDownIcon
        sx={{
          ...sharedClasses.dropdownIcon,
          transform: isOpen ? 'rotate(180deg)' : null
        }}
      />
    )}
  </Box>
);

export default CreateButton;
